import {
  Box,
  Button,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import { Step, Steps } from 'chakra-ui-steps'
import { ConfirmationStep } from 'types'

interface IConfirmationWithSteps {
  steps: ConfirmationStep[]
  activeStep: number
  isOpen: boolean
  onClose: (resetSteps?: boolean) => void
  errorMsg: string
}

// Just a visual aid for the user when the method involves multiple TXs to be confirmed
export const ConfirmationWithSteps = ({
  steps,
  activeStep,
  isOpen,
  onClose,
  errorMsg,
}: IConfirmationWithSteps) => {
  return (
    <Modal
      onClose={() => null}
      isOpen={isOpen}
      isCentered
      size={steps.length > 5 ? '5xl' : '3xl'}
    >
      <ModalOverlay />
      <ModalContent borderRadius="3xl">
        <ModalBody bg="darkish" fontFamily="mono" borderRadius="3xl">
          <Flex flexDir="column" width="100%" pt="24px" pb="0">
            <Steps
              state={
                !!errorMsg
                  ? 'error'
                  : steps[activeStep] && steps[activeStep].loading
                  ? 'loading'
                  : undefined
              }
              labelOrientation="vertical"
              activeStep={activeStep}
              size="sm"
            >
              {steps.map(({ label, content, icon }) => (
                <Step
                  key={label}
                  label={label}
                  icon={icon}
                  fontFamily="mono"
                  pb={{ base: 2, md: 0 }}
                >
                  <Box textAlign="center" pb={0} px={6}>
                    <Heading as="h2" size="lg" mt={6} mb={2} fontFamily="mono">
                      {label}
                    </Heading>
                    {errorMsg ? (
                      <Text
                        color={'gray.400'}
                        mb={6}
                        maxH={'50vh'}
                        overflowY={'auto'}
                      >
                        {errorMsg}
                      </Text>
                    ) : (
                      <Text color={'gray.400'} mb={6}>
                        {content}
                      </Text>
                    )}
                  </Box>
                </Step>
              ))}
            </Steps>
            {steps[activeStep] &&
            steps[activeStep].requiresUserAction &&
            !!steps[activeStep].CustomView ? (
              <Box mt={-3}>{steps[activeStep].CustomView}</Box>
            ) : null}
          </Flex>
          <Flex py={4} justifyContent="center" gap={3}>
            <Button
              _focus={{ boxShadow: 'none', outline: 'none' }}
              onClick={() => onClose(!!errorMsg)}
            >
              Close
            </Button>
            {!!steps[activeStep] &&
            !!steps[activeStep].requiresUserAction &&
            !!steps[activeStep].nextCallback ? (
              <Button
                onClick={steps[activeStep].nextCallback}
                colorScheme="brand"
                bgGradient="linear(to-b, brand.300, brand.500)"
                outline="none"
                color="white"
                _hover={{ bg: 'brand.300', boxShadow: 'md' }}
                _active={{
                  bg: 'brand.300',
                  transform: 'scale(0.98)',
                  borderColor: 'brand.300',
                }}
                _focus={{ boxShadow: 'none', border: 'none', outline: 'none' }}
              >
                Next
              </Button>
            ) : null}
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default ConfirmationWithSteps
